import { render, staticRenderFns } from "./VigilantAccessPage.vue?vue&type=template&id=318dacb8"
import script from "./VigilantAccessPage.vue?vue&type=script&lang=js"
export * from "./VigilantAccessPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports